import { render } from "./NetsPayment.vue?vue&type=template&id=141db532"
import script from "./NetsPayment.vue?vue&type=script&lang=js"
export * from "./NetsPayment.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__